<template>
    <span class="number-input button-group">
        {{ value }}
        <button type="button" @click.prevent.stop="setValue(-1)" class="dsn-button">
            <span>&minus;</span>
        </button>
        <button type="button" @click.prevent.stop="setValue(+1)" class="dsn-button">
            <span>+</span>
        </button>
    </span>
</template>

<script>
export default {
    name: 'number-input',
    props: ['value'],

    methods: {
        setValue(v) {
            this.$emit('input', this.value + v)
        },
    },
}
</script>

<style lang="scss">
.number-input {
    button {
        font-weight: bold;
    }
}
</style>
